import React from 'react'
import BaseComponent from './BaseComponent'
import Footer from './Footer'
import _ from 'lodash'
import { NavLink } from 'react-router-dom'
import SideNav from './SideNav'

export default class ArticlePage extends BaseComponent {

  render() {
  	const selectedArticle = _.filter(this.props.data.news, { slug: this.props.match.params.name })[0]

    return (
      <section className="article">
      	<ul className="breadcrumbs">
      		<div className="container-big">
	      		<li><NavLink to="/">Strona główna</NavLink></li>
	      		<li><NavLink to="/porady">Porady</NavLink></li>
	      		<li><NavLink to={ "/porady/artykul/" + selectedArticle.slug }>{ selectedArticle.title }</NavLink></li>
      		</div>
      		<div className="bottom"></div>
      	</ul>
        <div className="outer-container">
          <SideNav data={ this.props.data }/>
        	<div className="container">
            <div>
          		<div className="image" style={{ backgroundImage: "url(" + selectedArticle.image + ")" }}></div>
          		<h1>{ selectedArticle.title }</h1>
          		<div className="content" dangerouslySetInnerHTML={{ __html: selectedArticle.description }}></div>
            </div>
        	</div>
        </div>
      	<Footer data={ this.props.data } settings={ this.props.data.settings }/>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/ArticlePage.js